import {combineReducers} from 'redux';
import ReducerSidemenu from './ReducerSidemenu';
import ReducerActiveOption from './ReducerActiveOption';
import ReducerTable from './ReducerTable';
import ReducerSubTable from './ReducerSubTable';
import ReducerFormData from './ReducerFormData';
import ReducerFormOptions from './ReducerFormOptions';
import ReducerToggleForm from './ReducerToggleForm';
import ReducerDomains from './ReducerDomains';
import ReducerActivitiesInDomain from './ReducerActivitiesInDomain';
import ReducerFormFile from './ReducerFormFile';
import ReducerLogin from './ReducerLogin';
import ReducerUserId from './ReducerUserId';
import ReducerRoles from './ReducerRoles';
import ReducerFormTypes from './ReducerFormTypes';
import ReducerActivityType from './ReducerActivityType';

const allReducers = combineReducers({
    sidemenu: ReducerSidemenu,
    activeOption: ReducerActiveOption,
    table: ReducerTable,
    subTable: ReducerSubTable,
    formData: ReducerFormData,
    formFile: ReducerFormFile,
    formOptions: ReducerFormOptions,
    hideForm: ReducerToggleForm,
    domains: ReducerDomains,
    activities: ReducerActivitiesInDomain,
    types: ReducerFormTypes,
    logged: ReducerLogin,
    userId: ReducerUserId,
    userRoles: ReducerRoles,
    activityType: ReducerActivityType
});


export default allReducers; 


// WEBPACK FOOTER //
// ./src/reducers/index.js